import React from 'react';
import { EmptyState } from '../../../components/commons';
import { InvalidSearchImg } from '../../../images/images';
import styled from 'styled-components';

function DefaultComp() {
  return (
    <EmptyState
      img={InvalidSearchImg}
      heading='Under Development'
      subHeading='Please be patient :)'
      imageWidth='45rem'
    />
  );
}

export default DefaultComp;
